import { render, staticRenderFns } from "./EMelderComponentMeldenBs4EingabeTextNummerisch.vue?vue&type=template&id=28c8bbf2"
import script from "./EMelderComponentMeldenBs4EingabeTextNummerisch.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs4EingabeTextNummerisch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports